import React from "react";
import Aboutimage from "../../images/aktcorp/warehouse-one.png";

function Aboutimagediv() {
  return (
    <div className="w-full h-[40vh] sm:h-[40vh] md:h-[80vh] lg:h-screen overflow-hidden group">
      {/* Full-Width Image Section */}
      <div className="relative w-full h-full">
        <img
          src={Aboutimage}
          alt="About Us"
          className="absolute top-0 left-0 w-full h-full object-cover rounded-lg md:rounded-xl lg:rounded-2xl transition-transform duration-500 ease-in-out group-hover:scale-110"
        />
      </div>
    </div>
  );
}

export default Aboutimagediv;
